/**
 * Client-side CSV export - same UTF-8 BOM + quote-escaping approach as the
 * public Markets export, shared so no page ships a dead or mock button.
 */
export function exportCsv(filename, headers, rows) {
  const esc = (v) => {
    let s = v == null ? '' : String(v);
    // Defuse spreadsheet formula injection (=, +, @, or non-numeric -) from
    // untrusted strings while leaving plain negative numbers intact.
    if (/^[=+@]/.test(s) || (/^-/.test(s) && !/^-?\d+(\.\d+)?$/.test(s))) s = `'${s}`;
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [headers.map(esc).join(','), ...rows.map((r) => r.map(esc).join(','))];
  const blob = new Blob([`﻿${lines.join('\n')}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
